import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ApiService} from '../../../api.service';

@Component({
  selector: 'app-shaft',
  templateUrl: './shaft.component.html',
  styleUrls: ['./shaft.component.css']
})
export class ShaftComponent implements OnInit {

  shaft: {} = [];
  constructor(public restApi: ApiService) { }

  @Input() companyID: number;
  @Input() countryID: number;
  @Input() provinceID: number;
  @Input() areaID: number;

  @Output()
  selectedShaftID: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges) {
    this.loadShaft();
  }

  // Get employees list
  loadShaft() {
    return this.restApi.getShaft(this.companyID, this.countryID, this.provinceID, this.areaID).subscribe((data: {}) => {
      this.shaft = data;
    });
  }

  onChange(message) {
    this.selectedShaftID.emit(message);
  }

}
